import React from "react";
import { X, Lock, Sparkles, CheckCircle2 } from "lucide-react";

/**
 * Shown when backend returns 402 (free upload limit reached).
 * Props: { used, limit, onClose, onUpgrade }
 */
export default function UpgradeModal({ used, limit, onClose, onUpgrade }) {
  return (
    <div
      className="fixed inset-0 bg-[#0A0A0F]/95 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      data-testid="upgrade-modal"
      onClick={onClose}
    >
      <div
        className="cartiq-card max-w-md w-full relative overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="accent-bar absolute top-0 left-0 right-0" />
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 text-[#888] hover:text-[#F0EDE8]"
          data-testid="upgrade-close-btn"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-12 h-12 bg-[#FF6B00]/10 border border-[#FF6B00]/30 flex items-center justify-center mb-4">
          <Lock className="w-5 h-5 text-[#FF6B00]" />
        </div>

        <div className="text-[11px] uppercase tracking-[0.22em] text-[#FF6B00] font-bold mb-2">
          — Free limit reached
        </div>
        <h2 className="font-display uppercase text-3xl leading-tight mb-3">
          You've used <span className="text-[#FF6B00] font-mono-num">{used}</span> of{" "}
          <span className="font-mono-num">{limit}</span> free invoices.
        </h2>
        <p className="text-sm text-[#888] leading-relaxed mb-5">
          Pro unlocks unlimited uploads, WhatsApp automation, Saturday smart lists,
          and budget alerts that nudge you before you overspend.
        </p>

        <ul className="space-y-2.5 mb-6">
          {[
            "Unlimited PDF uploads across Blinkit, Zepto, Zomato, Swiggy",
            "Saturday 9 AM WhatsApp weekly smart list",
            "Budget alerts at 60%, 80%, 100%",
            "Reorder predictions per item",
            "Family plan available (4 members)",
          ].map((t, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              <CheckCircle2 className="w-4 h-4 text-[#1D9E75] shrink-0 mt-0.5" />
              <span className="text-[#F0EDE8]">{t}</span>
            </li>
          ))}
        </ul>

        <div className="grid grid-cols-3 gap-2 mb-4">
          <div className="bg-[#161620] border border-[#2A2A35] p-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#378ADD] font-bold mb-1">
              Starter
            </div>
            <div className="font-mono-num text-xl">
              ₹499<span className="text-[10px] text-[#888]">/mo</span>
            </div>
            <div className="text-[10px] text-[#555] uppercase tracking-wider mt-1">
              Grocery · WhatsApp
            </div>
          </div>
          <div className="bg-[#161620] border border-[#FF6B00]/40 p-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#FF6B00] font-bold mb-1">
              Pro
            </div>
            <div className="font-mono-num text-xl">
              ₹999<span className="text-[10px] text-[#888]">/mo</span>
            </div>
            <div className="text-[10px] text-[#555] uppercase tracking-wider mt-1">
              All platforms
            </div>
          </div>
          <div className="bg-[#161620] border border-[#2A2A35] p-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#1D9E75] font-bold mb-1">
              Family
            </div>
            <div className="font-mono-num text-xl">
              ₹1,999<span className="text-[10px] text-[#888]">/mo</span>
            </div>
            <div className="text-[10px] text-[#555] uppercase tracking-wider mt-1">
              4 members
            </div>
          </div>
        </div>

        <button
          type="button"
          className="btn-saffron w-full flex items-center justify-center gap-2"
          onClick={onUpgrade}
          data-testid="upgrade-cta-btn"
        >
          <Sparkles className="w-4 h-4" /> See all plans
        </button>
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#555] text-center mt-3">
          15-day free trial · Cancel anytime
        </div>
      </div>
    </div>
  );
}
